import { ErrorResponseEnum } from '@goalsetter/classroom-types/auth';

/** Where the auth app sends the user when the tenant site cannot be loaded. */
export function brandingFailurePath(error: unknown): string {
  const errorCode =
    typeof error === 'object' && error !== null && 'code' in error
      ? Number((error as { code: unknown }).code)
      : NaN;

  return errorCode === ErrorResponseEnum.ClientInactive
    ? '/site-unavailable'
    : '/something-went-wrong-error';
}
